import { useMemo, useState } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { ArrowLeftSLine, CheckLine } from '@assets/icons';

import {
  SortingTabsActiveLabelButton,
  SortingTabsContent,
  SortingTabsHeading,
  SortingTabsItem,
  SortingTabsPopover,
  SortingTabsPopoverContent,
  SortingTabsWrapper,
} from './SortingTabsStyle';

export interface SortingTabsProps {
  data: {
    id: string;
    label: string;
    disabled?: boolean;
  }[];
  activeKey: string;
  handleTabClick: (key: string) => void;
}

const SortingTabs = ({ data, activeKey, handleTabClick }: SortingTabsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const activeLabel = useMemo(
    () => data?.find((item) => item.id === activeKey)?.label,
    [data, activeKey]
  );

  return (
    <SortingTabsWrapper>
      <SortingTabsPopover
        open={isOpen}
        onOpenChange={setIsOpen}
        content={
          <SortingTabsPopoverContent>
            {data?.map((orderItem) => (
              <SortingTabsItem
                key={orderItem?.id}
                onClick={() => {
                  handleTabClick(orderItem?.id);
                  setIsOpen(false);
                }}
              >
                <span>{orderItem?.label}</span>
                {orderItem?.id === activeKey ? (
                  <CustomIcon
                    icon={CheckLine}
                    paletteColor='green600'
                    fontSize={20}
                  />
                ) : null}
              </SortingTabsItem>
            ))}
          </SortingTabsPopoverContent>
        }
        trigger='click'
        placement='bottom'
        getPopupContainer={(triggerNode) => triggerNode}
      >
        <SortingTabsContent>
          <SortingTabsHeading>Sıralama:</SortingTabsHeading>
          <SortingTabsActiveLabelButton isOpen={isOpen}>
            {activeLabel}
            <CustomIcon
              icon={ArrowLeftSLine}
              paletteColor='grey800'
              fontSize={24}
            />
          </SortingTabsActiveLabelButton>
        </SortingTabsContent>
      </SortingTabsPopover>
    </SortingTabsWrapper>
  );
};

export default SortingTabs;
